<template>
  <v-card style="max-width: 375px; width: 100%;">
    <v-card-title class="text-h4 mt-4">Nice to meet you.</v-card-title>
    <v-card-text>
      <v-text-field
        class="mt-4"
        variant="underlined"
        label="What's your name?"
        autocomplete="name"
        spellcheck="false"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        @keydown.enter="modelValue.trim() && $emit('submit')"
      />
      <div class="d-flex justify-end">
        <v-btn
          class="mt-6"
          color="primary"
          :disabled="!modelValue.trim()"
          @click="$emit('submit')"
        >
          LET'S GO!
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    modelValue: { type: String, required: true }
  },
  emits: ["update:modelValue", "submit"]
};
</script>
